let instance = null

export const registerContextMenu = (ref) => {
    instance = ref
}

export const openContextMenu = (config) => {
    if (instance) {
        instance.show(config)
    }
}

export const closeContextMenu = () => {
    if (instance) {
        instance.hide()
    }
}